import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageBootNotification } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';

import { LogItemWrapper } from './log-item-wrapper.component';

export const BootNotificationLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageBootNotification(log.message)) {
    Logger.error(
      'Message is not of type OcppLogCallResultMessageBootNotification',
      { log },
    );
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack direction="column" gap={GapEnum.M}>
        <Stack gap={GapEnum.M}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-boot-notification-request.charge-point-vendor',
            )}
          </Text>{' '}
          {log.message.parameters.chargePointVendor}
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-boot-notification-request.charge-point-model',
            )}
          </Text>{' '}
          {log.message.parameters.chargePointModel}
        </Stack>
      </Stack>
    </LogItemWrapper>
  );
};
